export const GTM_ID = {
    OPEN_GRAPH: eventDateId => `features-calendar-eventdetails-eventoptions-${eventDateId}`,
    OPEN_LINK_TEXT: eventDateId => `features-calendar-eventdetails-openlinktext-${eventDateId}`,
    ADD_EVENT: eventDateId => `features-calendar-eventdetails-addevent-${eventDateId}`,
    OPEN_DASHBOARD: eventDateId => `features-calendar-eventdetails-dashboard-${eventDateId}`,
    OPEN_SOURCE: eventDateId => `features-calendar-eventdetails-source-${eventDateId}`,
    OPEN_OVERVIEW: eventDateId => `features-calendar-eventdetails-overview-${eventDateId}`,
    CLOSE_OVERVIEW: eventDateId => `features-calendar-eventdetails-close-overview-${eventDateId}`,
    OPEN_RELATEDNEWS: eventDateId => `features-calendar-relatednews-${eventDateId}`,
    OPEN_READFULLREPORT: eventDateId => `features-calendar-eventdetails-readfullreport-${eventDateId}`,

    FILTER_TIME_BUTTON: timeRange => `features-calendar-filter-${timeRange.toLowerCase()}`,
    FILTER_TIME_DROPDOWN: 'features-calendar-filter-time',
    FILTER_TIME_DROPDOWN_OPTION: period => `features-calendar-timedropdown-${period.toLowerCase()}`,

    FILTER_CALENDAR_BUTTON: 'features-calendar-filter-calendar',
    FILTER_CALENDAR_CONTENT: 'features-calendar-filter-calendardropdown',

    FILTER_IMPACT_DROPDOWN: 'features-calendar-filter-impact',
    FILTER_IMPACT_DROPDOWN_OPTION: impact => `features-calendar-impactdropdown-${impact.toLowerCase()}`,

    FILTER_COUNTRY_DROPDOWN: 'features-calendar-filter-country',
    FILTER_COUNTRY_DROPDOWN_OPTION: country => `features-calendar-countrydropdown-${country.toLowerCase()}`,

    FILTER_CATEGORY_DROPDOWN: 'features-calendar-filter-category',
    FILTER_CATEGORY_DROPDOWN_OPTION: category => `features-calendar-categorydropdown-${category.toLowerCase()}`,

    FILTER_MY_FILTERS: 'features-calendar-filter-myfilters',
    FILTER_DEFAULTS: 'features-calendar-filter-defaults',
    FILTER_ADVANCED: 'features-calendar-filter-advancedfilters',

    MOBILE_FILTER_OPEN: 'features-calendar-filter-openfilter',
    MOBILE_FILTER_CLOSE: 'features-calendar-filter-closefilter',

    ADVANCED_FILTERS_TIME_BUTTON: timeRange => `features-calendar-advancedfilters-${timeRange.toLowerCase()}`,
    ADVANCED_FILTERS_TIME_DROPDOWN: 'features-calendar-advancedfilters-time',
    ADVANCED_FILTERS_TIME_DROPDOWN_OPTION: period => `features-calendar-filter-${period.toLowerCase()}`,

    ADVANCED_FILTERS_CALENDAR_BUTTON: 'features-calendar-advancedfilters-calendar',
    ADVANCED_FILTERS_CALENDAR_CONTENT: 'features-calendar-advancedfilters-calendardropdown',

    ADVANCED_FILTERS_IMPACT_CHECKBOX: impact => `features-calendar-filter-impact-${impact.toLowerCase()}`,
    ADVANCED_FILTERS_EVENT_NAME: 'features-calendar-advancedfilters-eventname',
    ADVANCED_FILTERS_COUNTRY_CHECKBOX: country => `features-calendar-filter-country-${country.toLowerCase()}`,
    ADVANCED_FILTERS_CATEGORY_CHECKBOX: category => `features-calendar-filter-category-${category.toLowerCase()}`,
    ADVANCED_FILTERS_SAVE_SETTINGS: 'features-calendar-filter-savesettings',
    ADVANCED_FILTERS_APPLY: 'features-calendar-filter-apply',
    ADVANCED_FILTERS_CANCEL: 'features-calendar-advancedfilters-cancel',

    TIMEZONE_DROPDOWN: 'features-calendar-timezone-selector',
    TIMEZONE_DROPDOWN_OPTION: timezone => `features-calendar-timezone-${timezone.toLowerCase()}`,
    TIMEZONE_TIMEFORMAT_24H: 'features-calendar-timezone-24h',
    TIMEZONE_TIMEFORMAT_AMPM: 'features-calendar-timezone-ampm',

    DOWNLOAD: 'features-calendar-configuration-download',
    ICSDOWNLOAD: 'features-calendar-configuration-downloadics',
    CSVDOWNLOAD: 'features-calendar-configuration-downloadcsv',
    NOTIFICATIONS: 'features-calendar-configuration-notifications',

    NOTIFY_ME_SUBSCRIPTION: eventDateId => `features-calendar-eventdetails-notifyme-subscription-${eventDateId}`,
    NOTIFY_ME_UNSUBSCRIPTION: eventDateId => `features-calendar-eventdetails-notifyme-unsubscription-${eventDateId}`,

    CONFIGURATION_HELP: 'features-calendar-configuration-help-button',

    DATEPIKER_TIMESELECTOR_BUTTON: 'features-calendar-datepicker-timeselector',
    DATEPIKER_OPTION: time => `features-calendar-datepicker-${time.toLowerCase()}`,
    DATEPIKER_APPLY: 'features-calendar-datepicker-apply',
    DATEPIKER_MONTH_SELECTOR: 'features-calendar-datepicker-monthselector',
    DATEPIKER_YEAR_SELECTOR: 'features-calendar-datepicker-yearselector',
    DATEPIKER_DAY_SELECTOR: 'features-calendar-datepicker-dayselector',

    CONFIGURATION_GEAR: 'features-calendar-configuration-gear',
    CONFIGURATION_MANAGE_EVENT_LIST: 'features-calendar-configuration-manage-event-list',

    HEADER_BASIC_VIEW: 'basic-calendar-view',
    HEADER_DEFAULT_VIEW: 'default-calendar-view',
    HEADER_PREMIUM_VIEW: 'premium-calendar-view'
}
export const GA4EVENT = {
    NAMES: { FEATURES_CALENDAR: "features-calendar" },
    ELEMENTS: {
        OPEN_GRAPH:  `eventdetails-eventoptions`,
        OPEN_LINK_TEXT:  `eventdetails-openlinktext`,
        ADD_EVENT:  `eventdetails-addevent`,
        OPEN_DASHBOARD:  `eventdetails-dashboard`,
        OPEN_SOURCE:  `eventdetails-source`,
        OPEN_OVERVIEW:  `eventdetails-overview`,
        CLOSE_OVERVIEW:  `eventdetails-close-overview`,
        OPEN_RELATEDNEWS:  `relatednews`,
        OPEN_READFULLREPORT:  `eventdetails-readfullreport`,
    
        FILTER_TIME_BUTTON: timeRange => `filter-${timeRange.toLowerCase()}`,
        FILTER_TIME_DROPDOWN: 'filter-time',
        FILTER_TIME_DROPDOWN_OPTION: period => `timedropdown-${period.toLowerCase()}`,
    
        FILTER_CALENDAR_BUTTON: 'filter-calendar',
        FILTER_CALENDAR_CONTENT: 'filter-calendardropdown',
    
        FILTER_IMPACT_DROPDOWN: 'filter-impact',
        FILTER_IMPACT_DROPDOWN_OPTION: impact => `impactdropdown-${impact.toLowerCase()}`,
    
        FILTER_COUNTRY_DROPDOWN: 'filter-country',
        FILTER_COUNTRY_DROPDOWN_OPTION: country => `countrydropdown-${country.toLowerCase()}`,
    
        FILTER_CATEGORY_DROPDOWN: 'filter-category',
        FILTER_CATEGORY_DROPDOWN_OPTION: category => `categorydropdown-${category.toLowerCase()}`,
    
        FILTER_MY_FILTERS: 'filter-myfilters',
        FILTER_DEFAULTS: 'filter-defaults',
        FILTER_ADVANCED: 'filter-advancedfilters',
    
        MOBILE_FILTER_OPEN: 'filter-openfilter',
        MOBILE_FILTER_CLOSE: 'filter-closefilter',
    
        ADVANCED_FILTERS_TIME_BUTTON: timeRange => `advancedfilters-${timeRange.toLowerCase()}`,
        ADVANCED_FILTERS_TIME_DROPDOWN: 'advancedfilters-time',
        ADVANCED_FILTERS_TIME_DROPDOWN_OPTION: period => `filter-${period.toLowerCase()}`,
    
        ADVANCED_FILTERS_CALENDAR_BUTTON: 'advancedfilters-calendar',
        ADVANCED_FILTERS_CALENDAR_CONTENT: 'advancedfilters-calendardropdown',
    
        ADVANCED_FILTERS_IMPACT_CHECKBOX: impact => `filter-impact-${impact.toLowerCase()}`,
        ADVANCED_FILTERS_EVENT_NAME: 'advancedfilters-eventname',
        ADVANCED_FILTERS_COUNTRY_CHECKBOX:  `filter-country`,
        ADVANCED_FILTERS_CATEGORY_CHECKBOX: category => `filter-category-${category.toLowerCase()}`,
        ADVANCED_FILTERS_SAVE_SETTINGS: 'filter-savesettings',
        ADVANCED_FILTERS_APPLY: 'filter-apply',
        ADVANCED_FILTERS_CANCEL: 'advancedfilters-cancel',
    
        TIMEZONE_DROPDOWN: 'timezone-selector',
        TIMEZONE_DROPDOWN_OPTION: `timezone-configgtm`,
        TIMEZONE_TIMEFORMAT_24H: 'timezone-24h',
        TIMEZONE_TIMEFORMAT_AMPM: 'timezone-ampm',
    
        DOWNLOAD: 'configuration-download',
        ICSDOWNLOAD: 'configuration-downloadics',
        CSVDOWNLOAD: 'configuration-downloadcsv',
        NOTIFICATIONS: 'configuration-notifications',
    
        NOTIFY_ME_SUBSCRIPTION:  `eventdetails-notifyme-subscription`,
        NOTIFY_ME_UNSUBSCRIPTION:  `eventdetails-notifyme-unsubscription`,
    
        CONFIGURATION_HELP: 'configuration-help-button',
    
        DATEPIKER_TIMESELECTOR_BUTTON: 'datepicker-timeselector',
        DATEPIKER_OPTION: time => `datepicker-${time.toLowerCase()}`,
        DATEPIKER_APPLY: 'datepicker-apply',
        DATEPIKER_MONTH_SELECTOR: 'datepicker-monthselector',
        DATEPIKER_YEAR_SELECTOR: 'datepicker-yearselector',
        DATEPIKER_DAY_SELECTOR: 'datepicker-dayselector',
    
        CONFIGURATION_GEAR: 'configuration-gear',
        CONFIGURATION_MANAGE_EVENT_LIST: 'configuration-manage-event-list',
    
        HEADER_BASIC_VIEW: 'basic-calendar-view',
        HEADER_DEFAULT_VIEW: 'default-calendar-view',
        HEADER_PREMIUM_VIEW: 'premium-calendar-view'
        }
}
